import PractitionerProfileForm from "./forms/Practitioner";
import StudentPractitionerProfileForm from "./forms/StudentPractitioner";
import YourDetailsForm from "./forms/YourDetails";
import StudentPractitionerUpgradePending from "./sections/StudentPractitionerUpgradePending";

export default function ProfileForm({ practitionerProfile }) {
  if (practitionerProfile?.currentPractitionerLevel) {
    if (!practitionerProfile?.currentPractitionerLevel.approved) {
      return (
        <>
          <YourDetailsForm practitionerProfile={practitionerProfile} />
          <StudentPractitionerUpgradePending
            level={practitionerProfile.currentPractitionerLevel.level}
          />
        </>
      );
    }

    if (practitionerProfile?.currentPractitionerLevel.level != "Full access") {
      return (
        <>
          <YourDetailsForm practitionerProfile={practitionerProfile} />
          <StudentPractitionerProfileForm practitionerProfile={practitionerProfile} />
        </>
      );
    }
  }

  // default
  return <PractitionerProfileForm practitionerProfile={practitionerProfile} />;
}
